
import professionalImage from '../assets/png/PROFESSIONAL.jpg'

export const headerData = {
    name: 'LAHIRU WIJESURIYA',
    title: "Hello! I am",
    desciption: "Senior Platform & DevOps Engineer with 5+ years architecting and implementing enterprise-scale AWS infrastructure. Proven ability to deliver what typically requires 4-6 engineers in 6-9 months - single-handedly, in just 1-3 months.",
    image: professionalImage,
    imagebw: professionalImage,
    resumePdf: '/Lahiru Wijesuriya CV 2025.pdf'
}
